import theme from "../../theme/theme";

export const styles = {
	root: {
		backgroundColor: "#f9f2e2",
		minHeight: "100vh",
		// padding: theme.spacing(4),
		fontFamily: '"Inter var"',

	},
	NavButtonTextStyle: {
		fontFamily: '"Inter var"',
		fontWeight: 500,
		fontSize: "18px",
		lineHeight: "100%",
		letterSpacing: "0%",
		padding: "auto 15px",
		backgroundColor: "hsba(31, 84%, 76%, 1)"
	},
	viewtextstyle: {
		fontFamily: '"Inter var"',
		fontWeight: 500,
		fontSize: "28px",
		lineHeight: "100%",
		letterSpacing: "0%",
		color: " #C1721F",
		marginY: "30px"
	},
	searchcancel: {
		backgroundColor: "#fff",
		color: " #C1721F",
		width: "111px",
		height: "40px",
		borderRadius: "999px",
		border: "1px solid  #C1721F",
		padding: "10px",
		gap: "10px",
		display: "flex",
		fontFamily: '"Inter var"',
		alignItems: "center",
		justifyContent: "center",
		fontWeight: 700,
		fontSize: "14px",
		lineHeight: "100%",
		"&:hover": {
			color: "white",
			backgroundColor: "#C1721F"
		}
	},
	skipButton: {
		backgroundColor: "rgb(244,213,107)",
		color: " #C1721F",
		width: "111px",
		height: "40px",
		borderRadius: "999px",
		border: "1px solid  #C1721F",
		padding: "10px",
		gap: "10px",
		display: "flex",
		fontFamily: '"Inter var"',
		alignItems: "center",
		justifyContent: "center",
		fontWeight: 700,
		fontSize: "14px",
		lineHeight: "100%",
		"&:hover": {
			color: "white",
			backgroundColor: "#C1721F"
		}
	},
	textstyle: {

		color: " #C1721F",
		fontFamily: '"Inter var"',
		fontWeight: 700,
		fontSize: "24px",
		lineHeight: "40px",
		letterSpacing: "0%",

		marginBottom: "20px"
	},
	content: {
		fontFamily: '"Inter var"',
		fontWeight: 400,
		fontSize: { xs: "16px", sm: "18px", md: "24px" },
		lineHeight: "34px",
		letterSpacing: "0%",
		textAlign: "center",
		color: "#333333",
		marginBottom: theme.spacing(2),
		padding: { xs: "0 10px", sm: "0 20px", md: 0 },
	},
	statsCard: {
		backgroundColor: "#ffffff",
		border: "3px solid #C1721F",
		borderRadius: theme.spacing(10),
		padding: theme.spacing(2),
		textAlign: "center",
		height: { xs: "auto", md: "132px" },
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: { xs: "100%", sm: "300px", md: "359px" },
		margin: { xs: "10px 0", md: 0 },
	},
	statsIcon: {
		color: "#C1721F",
		fontSize: "2.7rem",
		marginBottom: theme.spacing(1),
		marginRight: theme.spacing(4),
	},
	statsNumber: {
		color: "#333333",
		fontWeight: "bold",
		fontSize: "1.5rem",
		marginBottom: theme.spacing(0.5),
        fontFamily: '"Inter var"', 
	},
	statsText: {
		color: "#666666",
		fontSize: "1.0rem",
		fontFamily: '"Inter var"', 

	},
	processCard: {
		backgroundColor: "#ffffff",
		border: "2px solid #C1721F",
		borderRadius: theme.spacing(2),
		padding: theme.spacing(3),
		textAlign: "center",
		height: "200px",
		width: "200px",
		minHeight: "120px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	processText: {
		color: "#333333",
		fontFamily: '"Inter var"',
		fontWeight: 500,
		fontSize: "24px",
		lineHeight: "40px",
		letterSpacing: "0%",
		textAlign: "center",
	},
	processArrow: {
		color: "#d3a260",
		fontSize: "2rem",
		marginTop: { xs: "-50px", sm: "-20px" },
		marginLeft: "0px",
	},
	planCardStyles: {
		fontFamily: '"Inter var"',
		fontWeight: 700,
		fontSize: "28px",
		lineHeight: "100%",
		letterSpacing: "0%",
	},

	card: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px", xl: "1305px", xxl: "100%" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		marginLeft: { xs: "-15px", md: "auto" }
	},
	familycard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "100%", md: "100%", xl: "100%", xxl: "100%" },
		// height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		// marginLeft: { xs: "-15px", md: "auto" }
	},
	//"#87CEEB" link //
	faqcard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px", xl: "1305px", xxl: "100%" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	whyuse: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px", xl: "1305px", xxl: "100%" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		marginLeft: { xs: "0px", md: "5%" }

	},
	payuse: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },

		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px", xl: "1305px", xxl: "100%" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",

	},
	sucess: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px", xl: "1305px", xxl: "100%" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",

	},
	aboutcard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	carrercard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px" },
		height: { xs: "auto", md: "auto" },
		textAlign: "start",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	carrercardPopup:{
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "100%" },
		height: { xs: "auto", md: "auto" },
		textAlign: "start",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	Admincard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "100%" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	cmdcard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1405px" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	Carrercard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "800px" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	contactcard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1405px" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "auto", md: "45px" }
	},
	search: {
		backgroundColor: " #C1721F",
		color: "white",
		width: "111px",
		height: "40px",
		borderRadius: "999px",
		border: "1px solid",
		padding: "10px",
		fontWeight: 700,
		fontSize: "14px",
		lineHeight: "100%",
		fontFamily: '"Inter var"',
		gap: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	career: {
		backgroundColor: " #C1721F",
		color: "white",
		width: "300px",
		height: "auto",
		border: "1px solid",
		padding: "15px",
		fontWeight: 700,
		fontSize: "18px",
		lineHeight: "100%",
		fontFamily: '"Inter var"',
		gap: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginTop: "20px",
		"&:hover": {
			backgroundColor: " #C1721F",
			color: "white",
		}
	},
	careerButton: {
		backgroundColor: " #C1721F",
		color: "white",
		width: "150px",
		height: "auto",
		border: "1px solid",
		padding: "15px",
		fontWeight: 700,
		fontSize: "18px",
		lineHeight: "100%",
		fontFamily: '"Inter var"',
		gap: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginTop: "20px",
		"&:hover": {
			backgroundColor: " #C1721F",
			color: "white",
		}
	},
	cmd: {
		backgroundColor: " #C1721F",
		color: "white",
		width: "100%",
		height: "40px",
		border: "1px solid",
		padding: "10px",
		fontWeight: 700,
		fontSize: "18px",
		lineHeight: "100%",
		fontFamily: '"Inter var"',
		gap: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"&:hover": {
			backgroundColor: " #C1721F",
			color: "white",
		}
	},
	cardeducation: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1455px" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		margin: { xs: "0px auto", },
	},
	cardimage: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "90%", sm: "90%", md: "90%" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		marginLeft: { xs: "auto", sm: "5%" },
		marginRight: { xs: "5%" }
	},
	cardsuggetion: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		// marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "95%" },
		height: { xs: "auto", md: "auto" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	sug: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		// marginTop: theme.spacing(4),
		// marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: "auto",
		height: "auto",
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		width: { xs: "100%", sm: "90%", md: "auto" },
		height: { xs: "auto", md: "auto" },
	},
	font: {
		fontWeight: "bold",
		fontSize: { xs: "20px", sm: "20px", md: "20px", lg: "30px", xl: "30px", xxl: "30px" },
		display: "flex", justifyContent: "space-between"
	},
	fonts: {
		fontWeight: "bold",
		fontSize: { xs: "20px", sm: "20px", md: "20px", lg: "20px", xl: "20px", xxl: "25px" },
		display: "flex", justifyContent: "space-between"
	},
	cardShortlisted: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "90%", sm: "60%", md: "70%" },
		height: "auto",
		padding: "10px",
		marginLeft: { xs: "10px", sm: "5%" }
	},
	dashbordcard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px" },
		height: { xs: "auto", md: "294px" },
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},

	// formCard: {
	// 	borderRadius: theme.spacing(2),
	// 	padding: { xs: 4, sm: 3, md: 4 },
	// 	marginBottom: theme.spacing(4),
	// 	position: "relative",
	// 	boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
	// 	backgroundColor: "#ffffff",
	// 	overflow: "hidden",
	// 	width: { xs: "100%", sm: "80%", }
	// 	// maxWidth: { xs: "100%", sm: "90%", md: "2200px", lg: "3000px" },
	// },
	formCard: {
		borderRadius: theme.spacing(2),
		padding: { xs: 4, sm: 3, md: 4 },
		marginBottom: theme.spacing(4),
		position: "relative",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		backgroundColor: "#ffffff",
		overflow: "hidden",
		width: { xs: "100%", sm: "80%", md: "80%" }, // Set full width for all screens
		maxWidth: "100%", // Remove any maximum limit
		// marginLeft:{xs:"-15px",sm:"auto",md:"auto"}
	},

	formTitle: {
		fontFamily: '"Inter var"',
		fontWeight: 600,
		fontSize: "24px",
		lineHeight: "100%",
		letterSpacing: "0%",
		marginBottom: "30px",
	},
	heading: {
		color: "#c18e3d",
		textAlign: "center",
		marginBottom: { xs: 2, sm: 3, md: 4 },
		fontFamily: '"Inter var"',
		fontWeight: 400,
		fontSize: { xs: "28px", sm: "36px", md: "48px", xl: "48px", xxl: "90px" },
		lineHeight: "100%",
		letterSpacing: "0%",
	},
	heading1: {
		// color: "#c18e3d",
		// textAlign: "center",
		// marginBottom: { xs: 2, sm: 3, md: 4 },
		margin: 0,
		fontSize: "38px",
		lineHeight: 1.57,
		fontFamily: '"Inter var"',
		color: "rgb(91, 107, 121)",
		fontWeight: 400,
		// fontWeight: 400,
		// fontSize: { xs: "28px", sm: "36px", md: "48px",xl:"48px",xxl:"90px" },
		// lineHeight: "100%",
		// letterSpacing: "0%",
	},
	heading2: {
		color: "#c18e3d",
		textAlign: "center",
		marginBottom: { xs: 2, sm: 3, md: 4 },
		fontFamily: '"Inter var"',
		fontWeight: 400,
		fontSize: { xs: "28px", sm: "36px", md: "28px", xl: "28px", xxl: "90px" },
		lineHeight: "100%",
		letterSpacing: "0%",
	},
	iconStyles: {
		position: "absolute",
		// fontSize: "90px",
		opacity: 0.2,
		zIndex: 0,
		color: "#C1721F",
		width: "100px",
		height: "100px",
	},
	testimonialsCard: {
		border: "1.4px solid #C1721F",
		borderRadius: theme.spacing(3),
		padding: theme.spacing(3),
		display: "flex",
		flexDirection: { xs: "column", md: "row" },
		alignItems: "center",
		margin: "0 auto",
		width: "1011px",
		height: "316px",
	},
	aboutCard: {
		border: "1.4px solid #C1721F",
		borderRadius: "0px",
		padding: "10px",
		margin: "0 auto",
		width: "100%",
		height: "auto"
	},
	demopopup: {
		border: "1.4px solid #C1721F",
		borderRadius: "0px",
		padding: "10px",
		margin: "0 auto",
		width: "50%",
		height: "auto"
	},
	demovideo: {
		width: "100%",
		height: "300px",
		border: "2px solid #ccc",
		textAlign: "center",
		cursor: "pointer"
	},

	aboutText: {
		fontFamily: '"Inter var"',
		fontWeight: 400,
		fontSize: "24px",
		lineHeight: "34px",
		letterSpacing: "0%",
		textAlign: "justify",
		marginBottom: "10px",
		padding: "10px"
	},
	avatarContainer: {
		display: "flex",
		justifyContent: "center",
		marginRight: { xs: 0, md: theme.spacing(4) },
		marginBottom: { xs: theme.spacing(2), md: 0 },
		border: "2px solid #C1721F",
		borderRadius: "50%",
		padding: "4px",
		width: "220px",
		height: "220px",
	},
	avatar: {
		width: 180,
		height: 180,
		margin: "auto 0",
	},
	testimonialContent: {
		textAlign: "center",
		flex: 1,
		paddingLeft: { xs: 0, md: theme.spacing(2) },
	},
	testimonialText: {
		fontSize: "1.95rem",
		color: "#555555",
		marginBottom: theme.spacing(2),
		lineHeight: 1.6,
		fontFamily: '"Inter var"', 

	},
	coupleNames: {
		fontWeight: "bold",
		color: "#333333",
		textAlign: "center",
		fontFamily: '"Inter var"', 

	},
	marriageSource: {
		color: "#d3a260",
		fontWeight: "bold",
		textAlign: "center",
		fontFamily: '"Inter var"', 
		fontSize: "1.95rem",

	},
	dotsContainer: {
		display: "flex",
		justifyContent: "center",
		marginTop: theme.spacing(2),
	},
	reviewCard: {
		border: "1px solid #e0e0e0",
		borderRadius: theme.spacing(1),
		padding: theme.spacing(3),
		height: "327px",
		width: "353px",
		position: "relative",
		paddingTop: theme.spacing(5),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	quoteIcon: {
		color: "#f0f0f0",
		fontSize: "60px",
		position: "absolute",
		top: "10px",
		left: "10px",
		zIndex: 0,
	},
	reviewText: {
		fontSize: "1.98rem",
		color: "#555555",
		marginBottom: theme.spacing(1.5),
		position: "relative",
		zIndex: 1,
		fontFamily: '"Inter var"', 

	},
	reviewerInfo: {
		width: "100%",
		padding: "0px 10px",
		display: "flex",
		justifyContent: "space-between !important",
		alignItems: "center",
		marginTop: theme.spacing(2),
	},
	reviewerDetails: {
		marginLeft: theme.spacing(1.5),
		textAlign: "left",
	},
	reviewerName: {
		fontWeight: "bold",
		fontSize: "1.95rem",
		fontFamily: '"Inter var"', 

	},
	reviewerRole: {
		color: "#999999",
		fontSize: "0.85rem",
	},
	specialText: {
		textAlign: "center",
		mb: 1,
		fontFamily: '"Inter var"',
		fontWeight: 700,
		fontSize: { xs: '20px', sm: '36px' },
		lineHeight: "100%",
		letterSpacing: "0%",
		color: "linear-gradient(90deg, #000000 -7.17%, #C1721F 84.06%)",
		background: "linear-gradient(90deg, #000000 -7.17%, #C1721F 84.06%)",
		WebkitBackgroundClip: "text",
		WebkitTextFillColor: "transparent",
	},

	tabsContainerStyles: {
		display: "flex",
		justifyContent: "center",
		mb: 2,
		width: "100%",
		fontFamily: '"Inter var"',

	},

	tabStyles: {
		backgroundColor: "#f8e9c8",
		borderRadius: "50px",
		mx: 0.5,
		width: "328px",
		color: "#8a6d3b",
		height: "37px",
		"&.Mui-selected": {
			backgroundColor: "#e5cc9f",
			color: "#6b4e13",
			fontWeight: "bold",
		},
	},
	interstbutton: {
		width: { xs: "100%", sm: "auto", },//xl: "180px", xxl: "300px" 
		height: { xs: "40px", sm: "40px", xxl: "80px" },
		padding: "10px",
		borderRadius: "4px",
		backgroundColor: "green",
		color: "white",
		fontFamily: '"Inter var"',
		fontWeight: 600,
		fontSize: { xs: "18px", sm: "18px", md: "18px", xl: "16px", lg: "18px", xxl: "30px" },
		lineHeight: "100%",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "white",
			color: "black",
			border: "1px solid #C1721F",
			"& svg": {
				color: "black",
			},
		},
		"& svg": {
			color: "white",
		},
	},
	chip: {
		border: "1px solid green",
		backgroundColor: "white",
		color: "green",
		fontFamily: '"Inter var"',
		textTransform: "none",
		cursor: "pointer",
		width: { xs: "100%", sm: "auto" },
		padding: { xs: "8px 12px", sm: "10px 10px" },
		fontSize: { xs: "18px", sm: "18px", md: "18px", xl: "16px", lg: "18px", xxl: "30px" },
	},
	interstbuttonview: {
		width: { xs: "100%", sm: "auto", },//xl: "180px", xxl: "300px" 
		height: { xs: "40px", sm: "40px", xxl: "80px" },
		padding: "10px",
		borderRadius: "4px",
		backgroundColor: "#C1721F",
		color: "white",
		fontFamily: '"Inter var"',
		fontWeight: 600,
		fontSize: { xs: "18px", sm: "18px", md: "18px", xl: "16px", lg: "18px", xxl: "30px" },
		lineHeight: "100%",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "white",
			color: "black",
			border: "1px solid #C1721F",
			"& svg": {
				color: "black",
			},
		},
		"& svg": {
			color: "white",
		},
	},
	tabsStylespay: {
		display: "flex",
		justifyContent: "center",
		backgroundColor: "#dfdedc",
		fontFamily: '"Inter var"',
		borderRadius: "50px",
		width: { xs: "auto", sm: "auto", md: "auto", xl: "75%", xxl: "auto" },
		".MuiTabs-indicator": {
			display: "none",
		},
	},
	tabStylespay: {
		backgroundColor: "#dfdedc",
		borderRadius: "0px",
		color: "black",
		padding: { xs: "2px", sm: "25px" },
		width: "360px",//
		borderRight: "1px solid white",
		"&.Mui-selected": {
			backgroundColor: "#f8e9d3",
			color: "#6b4e13",
			fontWeight: "bold",
		},
	},

	tabsStyles: {
		".MuiTabs-indicator": {
			display: "none",
		},
		display: "inline-flex",
		backgroundColor: "#f8e9c8",
		borderRadius: "50px",
		padding: "5px",
		width: "70%",
	},
	newCard: {
		backgroundColor: "#ffffff",
		borderRadius: theme.spacing(2),
		padding: { xs: "20px", sm: "30px", md: "40px" },
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		position: "relative",
		overflow: "hidden",
		boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
		width: { xs: "100%", sm: "90%", md: "1305px" },
		height: { xs: "auto", md: "294px" },
		margin: { xs: "0px auto", },
	},
	menuitem: {
		cursor: "pointer",
		fontFamily: '"Inter var"',
		fontSize: { xs: "18px", sm: "18px", md: "18px", },
		"&:hover": {
			backgroundColor: "#C1721F",
			color: "white"
		}
	},
	menuitemheader: {
		cursor: "pointer",
		fontFamily: '"Inter var"',
		fontWeight: 600,
		// fontSize: "18px",
		fontSize: { xs: "18px", sm: "18px", md: "18px", xl: "18px", lg: "18px", xxl: "30px" },
		width: "auto",
		height: { xs: "47.4px", sm: "47.4px", lg: "47.4px", xl: "47.4px", xxl: "80px" },
		borderRadius: "4px",
		lineHeight: "100%",
		letterSpacing: "0%",
	},
	footerlink: {
		color: "white",
		cursor: "pointer",
		fontFamily: '"Inter var"',
		fontWeight: 510,
		fontSize: { xs: "23px", sm: "23px", md: "23px", lg: "23px", xl: "23px", xxl: "40px" },
		lineHeight: "100%",
		letterSpacing: "0px",
		marginBottom: "10px",
		"&:hover": {
			color: "#C1721F",
			textDecoration: "underline"
		}
	},
	iconbutton: {
		backgroundColor: "white",
		width: { xs: "30px", sm: "30px", md: "30px", xl: "30px", xxl: "50px" },
		height: { xs: "30px", sm: "30px", md: "30px", xl: "30px", xxl: "50px" },
		"&:hover": {
			backgroundColor: "#C1721F",
			color: "#fff",
		},
	},
	icon: {
		color: "white",
		cursor: "pointer",
		fontFamily: '"Inter var"',
		fontWeight: 510,
		// fontSize: "21px",
		fontSize: { xs: "21px", sm: "21px", md: "21px", lg: "21px", xl: "21px", xxl: "40px" },
		lineHeight: "100%",
		letterSpacing: "0px",
		marginBottom: "10px",
		"&:hover": {
			color: "#C1721F",
		}
	}
};
